import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Start expanded
    if (this.hasContentTarget) this.expand()
  }

  toggle() {
    if (this.isExpanded()) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  // Public API used by other controllers
  isExpanded() {
    return this.hasContentTarget && !this.contentTarget.classList.contains("max-h-0")
  }

  expand() {
    if (!this.hasContentTarget) return
    this.contentTarget.classList.remove("max-h-0", "mb-0")
    this.contentTarget.classList.add("max-h-[2000px]")
    if (this.hasIconTarget) this.iconTarget.textContent = "-"
  }

  collapse() {
    if (!this.hasContentTarget) return
    this.contentTarget.classList.remove("max-h-[2000px]")
    this.contentTarget.classList.add("max-h-0", "mb-0")
    if (this.hasIconTarget) this.iconTarget.textContent = "+"
  }
}